import "./AiFloatingAssistant.css";
import Robot from "./Robot";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const messages = [
    "Hi 👋",
    "How can I help you?",
    "Looking for something?",
    "Ask me anything 🤖",
    "Need the best deal?"
];

function AiFloatingAssistant() {

    const navigate = useNavigate();

    const [messageIndex, setMessageIndex] = useState(0);
    const [showBubble, setShowBubble] = useState(true);

    useEffect(() => {

        const messageInterval = setInterval(() => {

            setMessageIndex(prev => (prev + 1) % messages.length);

        }, 3500);

        return () => clearInterval(messageInterval);

    }, []);

    useEffect(() => {

        const bubbleInterval = setInterval(() => {

            setShowBubble(false);

            setTimeout(() => {

                setShowBubble(true);

            }, 1500);

        }, 9000);

        return () => clearInterval(bubbleInterval);

    }, []);

    return (

        <div
            className="ai-assistant"
            onClick={() => navigate("/ai")}
        >

            {showBubble && (

                <div className="assistant-bubble">

                    {messages[messageIndex]}

                </div>

            )}

            <Robot />

        </div>

    );

}

export default AiFloatingAssistant;